import styled from "styled-components"
import PaymentOk from "../../assets/undraw_order_confirmed.svg"
import PaymentNotOk from "../../assets/undraw_warning.svg"

const PaymentOkImage = styled(PaymentOk)`
  height: 500px;
  display: block;
  margin: 2rem auto 3rem auto;
  & *[fill="#6c63ff"] {
    fill: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  @media (max-width: 600px) {
    width: 100%;
    margin: 0 auto 0 auto;
    height: 300px;
  }
`

const PaymentNotOkImage = styled(PaymentNotOk)`
  height: 500px;
  display: block;
  margin: 2rem auto 3rem auto;
  & *[fill="#6c63ff"] {
    fill: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  @media (max-width: 600px) {
    width: 100%;
    margin: 0 auto 0 auto;
    height: 300px;
  }
`

const Title = styled.h1`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
  &::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

export { PaymentOkImage, PaymentNotOkImage, Title }
